var $ = require( 'jquery' );
import inview from 'jquery-inview/jquery.inview';
import Headroom from 'headroom.js';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.js';
import parallax from 'jquery-parallax.js/parallax.js';

var body = $('body, html');

$( document ).ready( function() {

	handleInviewAnimate();

	//Header
	initHeadroom();
	handleMobileMenuToggle();
	initLazyLoadElements();
	handleCF7Settings();
	//handleTopPageHover();

	//handleHeaderMenuHeight();

});

$( window ).on( 'load', function() {
    handleParallax();

	//preLoader();
	//handleHeaderMenuHeight();
	//handleFixedHeader();
});

$( window ).resize( function() {
	//handleHeaderMenuHeight();
	//handleFixedHeader();
});

function handleParallax() {
    const documentBody        = $( 'body' ),
          parallaxBackgrounds = $( '.parallax-window' );
    
    parallaxBackgrounds.each( ( iteration, element ) => {
        let thisParallaxWindow                  = $( element ),
            thisParallaxWindowBackground        = thisParallaxWindow.data( 'img-src' ),
            thisParallaxWindowBackgroundMobile  = thisParallaxWindow.data( 'img-mobile-src' ),
            thisParallaxWindowDelay             = thisParallaxWindow.parent( 'hero' ).length ? 0 : 200;

            // if ($(window).width() <= 767) {
            //     thisParallaxWindowBackground =  thisParallaxWindowBackgroundMobile;
            // }

        setTimeout( () => {
            if ( documentBody.hasClass( 'safari' ) || documentBody.hasClass( 'ie' ) || documentBody.hasClass( 'unknown' ) ) {
                thisParallaxWindow.addClass( 'attachment-fixed' ).css({
                    'background-image': 'url(' + thisParallaxWindowBackground + ')'
                });
            } else {
                thisParallaxWindow.parallax({
                    imageSrc: thisParallaxWindowBackground,
                    speed: 0.4
                });
                setTimeout( () => {
                    $('.parallax-mirror').css('opacity', '1');
                }, 100 );
            }
        }, thisParallaxWindowDelay );        
    });
}




function handleCF7Settings() {
    $('input.wpcf7-submit[type="submit"]').on('click', function() {
        var disabled = $(this).attr('data-disabled');
        if (disabled && disabled == 'disabled') {
            return false;
        } else {
            $(this).attr('data-disabled','disabled').addClass('hide-text');
            return true;
        }
    });

    $('.wpcf7').bind('wpcf7submit', function(){
        $(this).find('input.wpcf7-submit[type="submit"]').attr('data-disabled','enabled').removeClass('hide-text');
	});

	var positionName      = $( ".job-title" ).data( "form" ),
		positionFormInput = $( "#job-position" );

		positionFormInput.val( positionName );


	var contactFormUpload = $('.contact__upload'),
		contactFormFile	  = $('.contact__upload-name'),
		contactFormClear  = $('.contact__upload-clear'),
		contactFormWrap	  = $('.contact__upload-file');

	$('input[type="file"]').change(function(e){
		var fileName = e.target.files[0].name;
		contactFormFile.text(fileName);

		if (fileName != '') {
			contactFormWrap.show();
			contactFormUpload.hide();
		}
	});

	contactFormClear.on('click', function() {
		$('.wpcf7-file').val('');
		contactFormFile.text('');

		contactFormWrap.hide();
		contactFormUpload.show();
	})
	
	contactFormUpload.on('click', function() {
		$('.wpcf7-file').click();
	})
	
}

function initHeadroom() {
	var headerElements = document.getElementsByClassName("site-header"),
		headerElementsNo = headerElements.length;

	if ( headerElementsNo > 0 ) {
		for ( var i = 0; i < headerElementsNo; i++ ) {
			var headroom = new Headroom( headerElements[i] );
			headroom.init();
		}
	}
}

function initLazyLoadElements() {
    new LazyLoad({
        elements_selector: '.lazy',
    });
}

function handleTopPageHover() {
	var headerDesktop = $('.site-header--desktop'),
		  topSpace = 82;

	if ( $('body').hasClass('admin-bar') ) {
		topSpace = 92;
	}

	headerDesktop.hover(
		function(){ $(this).addClass('hover') },
		function(){ $(this).removeClass('hover') }
	)

	document.onmousemove = function handleMouseMove(event) {
		var eventDoc, doc, body;

		event = event || window.event; // IE-ism

		// If pageX/Y aren't available and clientX/Y are,
		// calculate pageX/Y - logic taken from jQuery.
		// (This is to support old IE)
		if (event.pageX == null && event.clientX != null) {
			eventDoc = (event.target && event.target.ownerDocument) || document;
			doc = eventDoc.documentElement;
			body = eventDoc.body;

			event.pageX = event.clientX +
				(doc && doc.scrollLeft || body && body.scrollLeft || 0) -
				(doc && doc.clientLeft || body && body.clientLeft || 0);
			event.pageY = event.clientY +
				(doc && doc.scrollTop  || body && body.scrollTop  || 0) -
				(doc && doc.clientTop  || body && body.clientTop  || 0 );
		}

		// Use event.pageX / event.pageY here
		mousePos = {
			x: event.pageX,
			y: event.pageY
		};

		if ( mousePos.y - $(window).scrollTop() < topSpace ) {
			if ( headerDesktop.hasClass('headroom--unpinned') ) {
				headerDesktop.removeClass('headroom--unpinned').addClass('headroom--pinned');
			}
		}
	};
}


// GLOBAL ANIMATION (just add classes where you wish animations)
function handleInviewAnimate() {
	var inviewElements = $( ".inview-animate--fade" )
		.add( ".inview-animate--move-up" )
		.add( ".inview-animate--move-down" )
		.add( ".inview-animate--move-left" )
		.add( ".inview-animate--move-right" )
		.add( ".inview-animate--scale" )
		.add( ".inview-element")

	inviewElements.each( function() {
		var thisInviewElement = $( this );

		thisInviewElement.bind( 'inview', function( event, visible ) {
			if ( visible == true ) {
				thisInviewElement.addClass( 'inview-active' );
			} /* else if ( thisInviewElement.is( ".inview-animate--fade, .inview-animate--scale" ) ) {
				thisInviewElement.removeClass( 'inview-active' );
			} */
		});
	});
}
function handleMobileMenuToggle() {
	var menuWrapper = $('.menu__main'),
		menuToggle = $('.menu__toggle');

	menuToggle.on('click', function() {
		$(this).toggleClass('close');
		menuWrapper.toggleClass('toggled');

		if (menuWrapper.hasClass('toggled')) {
			menuWrapper.closest('.site-header--mobile').addClass('toggled');
			$('body').css({ 
				overflow: 'hidden'
			});
		} else {
			menuWrapper.closest('.site-header--mobile').removeClass('toggled');
			$('body').css({ 
				overflow: ''
			});
		}
	});
}

function handleHeaderMenuHeight() {
	var windowWidth    = $( window ).width(),
		headerHeight   = $( "#header" ).outerHeight(),
		headerMenu     = $( "#header-menu" ),
		adminBar       = $( "#wpadminbar" ),
		adminBarHeight = adminBar.height();

	if ( adminBar.length && windowWidth >= 480 ) {
		var sectionOffset = adminBarHeight + headerHeight;
	} else {
		var sectionOffset = headerHeight;
	} 

	if ( headerMenu.length ) {
		headerMenu.css({ 
			height: 'calc(100vh - ' +  ( sectionOffset ) + 'px)'
		});
	}
}
